import { Preloader } from 'mmfintech-portal-commons'

const CustomPreloader = () => <Preloader />
export default CustomPreloader
